














import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryActivityInfoList, DeleteActivityInfo } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message, MessageBox } from 'element-ui'
import constant from '@/utils/constant'
import {ActivityInfoStatusFormat} from '@/utils/tyepconvert'
import CreateActivityInfoDialog from './CreateActivityInfoDialog.vue'
import UpdateActivityInfoDialog from './UpdateActivityInfoDialog.vue'
import ActivityApplyInfoDialog from './ActivityApplyInfoDialog.vue'

@Component({
  components: {
    VQuery,
    VTable,
    CreateActivityInfoDialog,
    UpdateActivityInfoDialog,
    ActivityApplyInfoDialog,
  },
})
export default class ActivityInfoList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
    endTime: '',
    endTimeq: null,
    sortType: 0,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  // 查询条件
  private queryModels: Array<QueryModel> = [
    { title: '排序方式', param: 'sortType' , type: 'select', selectData: constant.SortType},
    { title: '活动状态', param: 'activityStatus', type: 'select', selectData: constant.ActivityInfoStatus },
    { title: '活动编号', param: 'activeCode' },
    { title: '活动主题', param: 'activityTheme' },
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [{ title: '创建活动', type: 'primary', click: this.openCreate }]
  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '活动编号', param: 'activeCode',overflow:true },
    { title: '活动主题', param: 'activityTheme',overflow:true },
    { title: '活动地点', param: 'activityAddr',overflow:true },
    { title: '活动开始时间', param: 'activityStartTime', formatter: DateFormat },
    { title: '活动状态', param: 'activityStatus', formatter: ActivityInfoStatusFormat },
    { title: '排序', param: 'sort' },
    { title: '创建时间', param: 'createTime', formatter: DateFormat },
    {
      title: '操作',
      operation: [
        { title: '查看详情', icon: 'el-icon-document', click: this.openDesc },
        { title: '报名表', icon: 'el-icon-edit', click: this.openApply },
        { title: '修改', icon: 'el-icon-edit', click: this.openUpdate },
        { title: '删除', icon: 'el-icon-delete', class: 'red', click: this.deleteRow },
      ],
    },
  ]

  private openCreate(){
    const d = this.$refs.CreateActivityInfoDialog as CreateActivityInfoDialog
    d.open()
  }

  private openDesc(data: any){
     const d = this.$refs.DescActivityInfoDialog as UpdateActivityInfoDialog
    d.open(data)
  }

  private openUpdate(data: any){
    const d = this.$refs.UpdateActivityInfoDialog as UpdateActivityInfoDialog
    d.open(data)
  }

  // 查看报名
  private openApply(data: any){
    const d = this.$refs.ActivityApplyInfoDialog as ActivityApplyInfoDialog
    d.open(data)
  }

  public async created() {
    this.loadData()
  }


  public async loadData() {
    const param: any = { ...this.queryParam }
    if (param.endTimeq) {
      param.endTime = ',' + param.endTimeq
    }
    if(this.queryParam.sortType == 0){
      param.orderBy = "sort desc, create_time desc"
    }

    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    const result = await QueryActivityInfoList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  public search() {
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }

  // 删除单行数据
  public deleteRow(data: any) {
    console.log(data)
    MessageBox.confirm('确定要删除吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await DeleteActivityInfo({ activeCode: data.activeCode })
      if (ruslt) {
        Message.success('删除成功')
        this.loadData()
      }
    })
  }
}
